import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/automations/')({
    beforeLoad: ({ location }) => {
        throw redirect({
            to: '/admin/agent/automations',
            search: location.search,
            replace: true,
        });
    },
    component: () => null,
});
